import React, { useRef, useState } from 'react';
import { getProductsByQuery } from '../../Services/ProductList.Service';
import inputDelay from '../../Services/inputDelay';
import useOutsideClickAction from '../../Services/useOutsideClickAction';
import { translate } from '../../Services/translation';

const CheckoutProductListAutoSelect = ({ onSelect }) => {
  const dropdownRef = useRef();
  const dropdownContainerRef = useRef();
  const [productList, setProductList] = useState();

  const handleSearchProduct = (q) => {
    getProductsByQuery(q).then((result) => {
      if (result && result.length > 0) {
        setProductList(
          result.map((v) => ({
            name: v.name,
            id: v.item.selectedVariant.id,
          }))
        );
      }
    });
    dropdownRef.current.style.display = '';
  };

  const handleSearchProductDelayed = inputDelay(handleSearchProduct, 500);
  useOutsideClickAction(dropdownContainerRef, () => {
    dropdownRef.current.style.display = 'none';
  });

  return (
    <div>
      <b>{translate('checkout.addproduct')}</b>
      <div className="checkout__article-number" ref={dropdownContainerRef}>
        <input
          type="text"
          placeholder={translate('checkout.productnumber')}
          onChange={(event) => {
            const value = event.currentTarget.value;
            handleSearchProductDelayed(value);
          }}
          onClick={() => {
            if (dropdownRef.current.style.display === 'none') {
              dropdownRef.current.style.display = '';
            }
          }}
        />
        <div
          className="checkout__dropdown_product_list"
          ref={dropdownRef}
          style={{
            display: 'none',
          }}
        >
          {productList &&
            productList.map((v) => (
              <div
                key={v.id}
                role="button"
                onClick={() => {
                  onSelect(v.id);
                  dropdownRef.current.style.display = 'none';
                }}
              >
                {v.name} ({v.id})
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default CheckoutProductListAutoSelect;
